import { useEffect } from 'react';
import { useCloseModal, useOpenModal } from 'src/common/components/next-modal';
import { useOpenDeleteSyncBlockDialog } from 'src/components/unsync';
import { ActivityIds } from 'src/hooks/activities/activity-ids';
import { useUpdateTask } from 'src/hooks/activities/use-update-task';
import { ActivitiesListType } from 'src/hooks/activities/use-activity';
import { useClearSelectedCellValue } from 'src/hooks/block/use-clear-selected-cell-value';
import { useCreatePropertyOption } from 'src/hooks/block/use-create-property-options';
import { useDeleteSelectedTableCells } from 'src/hooks/block/use-delete-selected-table-calls';
import { useUpdatePropertyValueWithoutTransaction } from 'src/hooks/block/use-update-property-value';
import { useUpload } from 'src/hooks/space/use-upload';
import { useTransaction } from 'src/hooks/use-transaction';
import { useFetchPage } from '../use-fetch-page';
import { useSelectedBlockHistory } from '../use-selected-block-history';
import { onCutCopy } from './on-cut-copy';
import { onPaste } from './on-paste';
import { Action } from './types';

/** 全局 copy 监听 */
export const useCopyListener = (readonly?: boolean) => {
  const transaction = useTransaction();
  const updateTask = useUpdateTask();
  const closeModal = useCloseModal();
  const { selectedBlockHistory } = useSelectedBlockHistory();
  const upload = useUpload();
  const openModal = useOpenModal();
  const clearSelectedCellValue = useClearSelectedCellValue();
  const updatePropertyValueWithoutTransaction = useUpdatePropertyValueWithoutTransaction();
  const createPropertyOption = useCreatePropertyOption();
  const openDeleteSyncBlockDialog = useOpenDeleteSyncBlockDialog();
  const deleteSelectedTableCells = useDeleteSelectedTableCells();
  const fetchPage = useFetchPage();
  const common = {
    transaction,
    selectedBlockHistory,
    clearSelectedCellValue,
    readonly,
    closeModal,
    openDeleteSyncBlockDialog,
    deleteSelectedTableCells,
  };
  const handleCut = onCutCopy(common)(Action.CUT);
  const handleCopy = onCutCopy(common)(Action.COPY);
  const handlePaste = onPaste({
    ...common,
    fetchPage,
    uploadFile: upload,
    openModal,
    createPropertyOption,
    updatePropertyValueWithoutTransaction,
    uploadFileSuccess: () => {
      // 积分任务
      void updateTask(ActivityIds.GUIDE_FIRST_TIME_UPLOAD, ActivitiesListType.basicList);
    },
    pasteSyncBlock: () => {
      // 积分任务
      void updateTask(ActivityIds.CREATE_SYNC_BLOCK_NEW, ActivitiesListType.advancedList, {
        step2: true,
      });
    },
  });

  useEffect(() => {
    document.addEventListener('cut', handleCut, { capture: true });
    document.addEventListener('copy', handleCopy);
    document.addEventListener('paste', handlePaste, { capture: true });

    return () => {
      document.removeEventListener('cut', handleCut, { capture: true });
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('paste', handlePaste, { capture: true });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
